import { render, staticRenderFns } from "./TestGridOverlay.html?vue&type=template&id=396a8aae&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./TestGridOverlay.scss?vue&type=style&index=0&id=396a8aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396a8aae",
  null
  
)

export default component.exports